import React from 'react';

const SvgCheckboxSporadic = ({ size = 13, ...props }) => {
    return (
        <svg width={size} height={size} viewBox='0 0 13 13' {...props}>
            <rect
                ry={2}
                rx={2}
                y={0.5}
                x={0.5}
                height={12}
                width={12}
                fill='#fff'
                fillRule='evenodd'
                stroke='#b2b2b2'
            />
            <rect
                ry={1}
                rx={1}
                y={2.5}
                x={2.5}
                height={8}
                width={8}
                fill='#414141'
                fillRule='evenodd'
            />
        </svg>
    );
};

const MemoSvgCheckboxSporadic = React.memo(SvgCheckboxSporadic);
export default MemoSvgCheckboxSporadic;
